import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-300"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.195 1.897h.007a.5.5 0 0 0 .493-.506L5.683.486a.5.5 0 0 0-.5-.493h-.007a.5.5 0 0 0-.493.506l.012.904a.5.5 0 0 0 .5.494zm-2.892.946a.5.5 0 1 0 .698-.716l-.648-.63a.5.5 0 1 0-.697.715zm-.179 2.203a.5.5 0 0 0-.5-.494h-.007l-.904.012a.5.5 0 0 0 .006 1h.007l.905-.012a.5.5 0 0 0 .493-.506zm5.638-2.121a.5.5 0 0 0 .359-.15l.63-.648a.5.5 0 0 0-.716-.698l-.631.647a.5.5 0 0 0 .358.85zm4.254 2.647a2.938 2.938 0 0 0-.37.037 4.364 4.364 0 0 0-7.315 0 2.937 2.937 0 0 0-.37-.037 2.972 2.972 0 1 0 1.16 5.708 4.302 4.302 0 0 0 5.734 0 2.972 2.972 0 1 0 1.161-5.708zm0 4.944a1.959 1.959 0 0 1-.77-.156 1 1 0 0 0-1.049.168 3.302 3.302 0 0 1-4.418 0 1 1 0 0 0-1.049-.168 1.972 1.972 0 1 1-.77-3.788 1.075 1.075 0 0 1 .15.016l.096.013a1 1 0 0 0 .961-.444 3.364 3.364 0 0 1 5.642 0 1 1 0 0 0 .962.444l.096-.013a1.078 1.078 0 0 1 .149-.016 1.972 1.972 0 1 1 0 3.944zM2.47 5.308a3.53 3.53 0 0 1 1.018-.288 1.831 1.831 0 0 1 1.811-1.603 1.809 1.809 0 0 1 .553.094 4.927 4.927 0 0 1 1.282-.404 2.82 2.82 0 0 0-4.67 2.145c0 .02.006.037.006.056zM9.53 15a1 1 0 0 0 2 0 6.604 6.604 0 0 0-1-2 6.604 6.604 0 0 0-1 2zm-5.083 0a1 1 0 0 0 2 0 6.604 6.604 0 0 0-1-2 6.604 6.604 0 0 0-1 2z",
  style: {"fill-rule":"evenodd"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }